module.exports = __webpack_public_path__ + "img/pig_face.f1f7ebd6.gif";